const deviceIdRoutes = [
  "v3/auth/signin",
  "v3/auth/google-signin",
  "v3/auth/signout",

  "v3/dashboard/user/:userId/change-password",
];

export default deviceIdRoutes;
